import { lazy }  from "react";
import ReactDOM from "react-dom";
import { Provider } from 'react-redux'
import { useCheckAccess } from "./hooks/useCheckAccess";
import { store } from './store.js'
import Loadable from "./General/Loadable.jsx";
import { setEntry } from "./EntryHelpers/setEntry.js";
import { useRootCssVars } from "./hooks/useRootCssVars.js";

const PageFront = Loadable(lazy(() => import("./PageFront/index.jsx")))
const PageFrontOverview = Loadable(lazy(() => import("./PageFrontOverview/index.jsx")))
const PageFrontAccess = Loadable(lazy(() => import("./PageFrontAccess/PageFrontAccess.jsx")))

const AccessWrapperFront = ({isMobile, isWebApp}) => {
    const useAccesTheme = useCheckAccess() 
    useRootCssVars(useAccesTheme)

    if(useAccesTheme) {
        return <PageFrontAccess />
    } else if((isMobile || isWebApp)) {
        return <PageFrontOverview isMobile={isMobile} isWebApp={isWebApp} />
    } else {
        return <PageFront isWebApp={isWebApp} />
    }
}

const elem = document.querySelector("#front-page")

if(elem)  {
    const [isWebApp, isMobile] = setEntry()

    ReactDOM.render(
        <Provider store={store}>
            <AccessWrapperFront isMobile={isMobile} isWebApp={isWebApp}/>
        </Provider>
    , elem)
}
